import Vue from "vue";
export default Vue.extend({
    props: ["absence"],
    methods: {
        parseAbsence(item) {
            const absence = {
                date: "",
                type: "",
                duration: "",
            };
            const regex = /(?<date>\d+\s[a-zA-Z]+),\s(?<type>[a-zA-Z]+)?\s?\(?(?<duration>[0-9]*)h?\)?/;
            const result = regex.exec(item);
            if (result != null && result.groups != null) {
                absence.date = result.groups.date;
                absence.type = result.groups.type;
                absence.duration = result.groups.duration || "8";
            }
            return absence;
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Date",
                    value: "date",
                },
                {
                    text: "Type",
                    value: "type",
                },
                {
                    text: "Duration",
                    value: "duration",
                },
            ],
        };
    },
});
